import { render, staticRenderFns } from "./SongDetails.vue?vue&type=template&id=6ad30daf&scoped=true"
import script from "./SongDetails.vue?vue&type=script&lang=ts"
export * from "./SongDetails.vue?vue&type=script&lang=ts"
import style0 from "./SongDetails.vue?vue&type=style&index=0&id=6ad30daf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad30daf",
  null
  
)

export default component.exports